// import PUBLIC_KEY_PEM from "@/secrets/public_key_login.pem?raw";

export const useClientCrypto = () => {
    let _pubKey: CryptoKey | null = null;
    const PUBLIC_KEY_PEM ="-----BEGIN PUBLIC KEY-----MIIBojANBgkqhkiG9w0BAQEFAAOCAY8AMIIBigKCAYEA8XlrVaWyI55OSnWfmsKcYpqBfKnjlZk08hCjYQaJwOOvzwGRsOIBUoDNE+mn5JAX4aSieiF0T53J40JglJiA7hPoJdZUzaDh//VGO5CsjH+MWv1iagOdY9cXK150KgYk5XR2irouONUReAcpElaG4PANbwxOc8aM0JNFtrjGecJJExMH7a2z7wUm6miOlYyoBPyKOWhK2jxHnwb6khG7LIG8+S5vWmTPtMEUs52IrBTIiwXR8WHUtFIaKOuDV4KQXwEJoLsgjmUw9eiQS/qAG4zztXQ8X9Bb+EXo+E9XWZeRnQJHBTaw977NZwuRXNO7/yjbxE7f+sMaWhFifmG6uQsSXpMk0OnSB8e3xa1gm8vRkzKF6I15i6T6UjkAtZjkJ5g8nb+NLkiCgrSPxpEAXDIr989rYgHx5Ggid4DEoa40SoFF5kghkT5ovT0DO/7GwwKzNItDeNEzf5rYJKQNcyxGignpVnWt5bmKIu1NKbDjwie0DqStmvVkL86bc6k1AgMBAAE=-----END PUBLIC KEY-----"
    const importPublicKey = async () => {
        if (_pubKey) return _pubKey;
        const spki = PUBLIC_KEY_PEM.replace(/-----[^-]+-----/g, "").replace(
            /\s+/g,
            ""
        );
        const raw = Uint8Array.from(atob(spki), (c) => c.charCodeAt(0)).buffer;
        _pubKey = await crypto.subtle.importKey(
            "spki",
            raw,
            { name: "RSA-OAEP", hash: "SHA-256" },
            false,
            ["encrypt"]
        );
        return _pubKey;
    };

    const b64url = (buf: ArrayBuffer) => {
        const bin = String.fromCharCode(...new Uint8Array(buf));
        return btoa(bin).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
    };

    const encryptLoginPayload = async (login: string, password: string) => {
        const key = await importPublicKey();
        const wrapped = {
            login,
            password,
            ts: Date.now(),
            nonce: crypto.getRandomValues(new Uint32Array(1))[0].toString(16),
        };
        const data = new TextEncoder().encode(JSON.stringify(wrapped));
        const ct = await crypto.subtle.encrypt({ name: "RSA-OAEP" }, key!, data);
        return b64url(ct);
    };

    return { encryptLoginPayload };
};
